import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import CartIcon from '@material-ui/icons/ShoppingCart';
import LockIcon from '@material-ui/icons/Lock';

import { Context as CartContext } from '../../context/cart.context';
import { Context as AuthContext } from '../../context/auth.context';

let invoicePaid = false;

const useStyles = makeStyles((theme) => ({
	paper: {
		backgroundColor: theme.palette.background.paper,
		padding: theme.spacing(2, 4, 3),
		outline: 'none',
		borderRadius: 8,
		width: '100%',
	},
	// table: {
	//   minWidth: 650,
	// },
}));

const numberWithCommas = (x) => {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const Cart = () => {
	const classes = useStyles();
	const { state, setCartVisible, removeFromCart, setInvoiceDependencyRemoved } =
		React.useContext(CartContext);
	const auth = React.useContext(AuthContext);

	useEffect(() => {
		let vh = window.innerHeight * 0.01;

		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}, []);

	const handleClose = () => {
		setCartVisible(false);
		setInvoiceDependencyRemoved(false);
	};

	return (
		<Modal
			aria-labelledby="transition-modal-title"
			aria-describedby="transition-modal-description"
			id="cart-modal"
			open={state.cartVisible}
			onClose={handleClose}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 500,
			}}
		>
			<Fade in={state.cartVisible}>
				<div id="cart-content">
					<div style={styles.topBar}>


						<div style={styles.title}>
							<Typography variant="h4">Cart</Typography>
							<div style={{ width: 25 }} />
							<CartIcon style={{ fontSize: 30 }} />
						</div>

						{state.invoiceDependencyRemoved === true &&(
							<Typography
								align="center"
								style={{
									border: '2px solid #ffcccb',
									padding:10
								}}
							>
								More then one invoice was removed due to dependency.

								<Button
									style={{marginLeft:20}}
									variant="contained"
									onClick={() => setInvoiceDependencyRemoved(false)}
								>
									Dismiss
								</Button>
							</Typography>
						)}

						<IconButton onClick={() => handleClose()}>
							<CloseIcon />
						</IconButton>
					</div>


					{state.shoppingCart.length < 1 ? (
						<div
							style={{
								paddingTop: 80,
								paddingBottom: 80,
								textAlign: 'center',
							}}
						>
							<Typography
								variant="subtitle1"
								style={{ fontSize: 18 }}
							>
								Cart is Empty
							</Typography>
						</div>
					) : (
						<>
							<Table
								className={classes.table}
								aria-label="simple table"
							>
								<TableHead id="property-details-full">
									<TableRow
										style={{
											background: '#ECF1F5 !important',
											fontWeight: 'bold',
										}}
									>
										<TableCell
											style={{ background: '#ECF1F5' }}
										>
											Name
										</TableCell>
										{auth.state.merchant.enableCoris == 1 && (
											<TableCell
												style={{ background: '#ECF1F5' }}
											>
												Case Number
											</TableCell>
										)}
										<TableCell
											align="left"
											style={{ background: '#ECF1F5' }}
										>
											{auth.state.merchant.enableCoris == 1 ? 'Citiation Number' : auth.state.merchant.accountLabel}
										</TableCell>
										{auth.state.merchant.enableCoris == 0 && (
											<>
												<TableCell
													align="left"
													style={{ background: '#ECF1F5' }}
												>
													Tax Year
												</TableCell>
												<TableCell
													align="left"
													style={{ background: '#ECF1F5' }}
												>
													Record Type
												</TableCell>
												<TableCell
													align="left"
													style={{ background: '#ECF1F5' }}
												>
													Owner
												</TableCell>
											</>
										)}
										<TableCell
											align="right"
											style={{ background: '#ECF1F5' }}
										>
											Amount
										</TableCell>
										<TableCell
											align="right"
											style={{ background: '#ECF1F5' }}
										></TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{state.shoppingCart.sort((a, b) => b.taxYear - a.taxYear ).map((row) => (
										<>
											<TableRow
												key={row.account}
												id="property-details-full"
											>
												<TableCell
													component="th"
													scope="row"
												>
													{row.ownerName}
												</TableCell>
												{auth.state.merchant.enableCoris == 1 && (
													<TableCell
														component="th"
														scope="row"
													>
														{row.invoiceID}
													</TableCell>
												)}
												<TableCell align="left">
													{auth.state.merchant.enableCoris == 1 && row.account != row.invoiceId && (row.account)}
													{auth.state.merchant.enableCoris != 1 && (row.account)}
												</TableCell>
												{auth.state.merchant.enableCoris == 0 && (
													<>
														<TableCell align="left">
															{row.taxYear}
														</TableCell>
														<TableCell align="left">
															{row.recordType}
														</TableCell>
														<TableCell align="left">
															{row.ownerName}
														</TableCell>
													</>
												)}
												<TableCell align="right">
													$
													{numberWithCommas(
														row.finalBalanceCheck.toFixed(2)
													)}
												</TableCell>
												<TableCell
													align="right"
													style={{ width: 150 }}
												>
													<Button
														variant="contained"
														startIcon={
															<CloseIcon />
														}
														onClick={() =>
															removeFromCart({
																cartItem: row,
																cart: state.shoppingCart,
															})
														}
													>
														Remove
													</Button>
												</TableCell>
											</TableRow>
											<div className="cart-mobile">
												<div
													style={{
														width: '100%',
														display: 'flex',
														flexDirection: 'row',
													}}
												>
													<div
														style={{
															display: 'flex',
															flexDirection:
																'column',
															width: '100%',
														}}
													>
														<Typography variant="caption">
															{auth.state.merchant.enableCoris == 1 ? 'Name' : 'Owner Name'}
														</Typography>
														<Typography
															variant="body1"
															style={{
																marginBottom: 8,
																fontWeight:
																	'bold',
															}}
														>
															{row.ownerName}
														</Typography>
														{auth.state.merchant.enableCoris == 1 && (
															<>
																<Typography variant="caption">
																	Case Number
																</Typography>
																<Typography
																	variant="body1"
																	style={{
																		marginBottom: 8,
																		fontWeight:
																			'bold',
																	}}
																>
																	{row.invoiceID	}
																</Typography>
															</>
														)}
														<Typography variant="caption">
															{auth.state.merchant.enableCoris == 1? 'Citiation Number' : auth.state.merchant.accountLabel}
														</Typography>
														<Typography
															variant="body1"
															style={{
																marginBottom: 8,
																fontWeight:
																	'bold',
															}}
														>
															{auth.state.merchant.enableCoris == 1 && row.account != row.invoiceId && (row.account)}
															{auth.state.merchant.enableCoris != 1 && (row.account)}
														</Typography>
														{auth.state.merchant.enableCoris == 0 && (
															<>
																<Typography variant="caption">
																	Record Type
																</Typography>
																<Typography
																	variant="body1"
																	style={{
																		marginBottom: 8,
																		fontWeight:
																			'bold',
																	}}
																>
																	{row.recordType}
																</Typography>
															</>
														)}
													</div>
													<div
														style={{
															display: 'flex',
															flexDirection:
																'column',
															width: '100%',
															alignItems:
																'flex-end',
														}}
													>
														{auth.state.merchant.enableCoris == 0 && (
															<>
																<Typography variant="caption">
																	Tax Year
																</Typography>
																<Typography
																	variant="body1"
																	style={{
																		marginBottom: 8,
																		fontWeight:
																			'bold',
																	}}
																>
																	{row.taxYear}
																</Typography>
															</>
														)}
														<Typography variant="caption">
															Amount
														</Typography>
														<Typography
															variant="body1"
															style={{
																marginBottom: 8,
																fontWeight:
																	'bold',
															}}
														>
															$
															{numberWithCommas(
																row.finalBalanceCheck.toFixed(
																	2
																)
															)}
														</Typography>
														<Button
															variant="contained"
															startIcon={
																<CloseIcon />
															}
															onClick={() =>
																removeFromCart({
																	cartItem:
																		row,
																	cart: state.shoppingCart,
																})
															}
														>
															Remove
														</Button>
													</div>
												</div>

												{/* {!row.paid ? <AddToCart cartItem={row} /> : null} */}
											</div>
										</>
									))}
								</TableBody>
							</Table>
							<TableRow
								style={{
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'flex-end',
									alignItems: 'center',
									width: '100%',
								}}
							>
								<TableCell
									align="right"
									style={{
										fontWeight: 'bold',
										border: 'none',
										fontSize: 18,
										margin: 0,
									}}
								>
									Total
								</TableCell>
								<TableCell
									align="right"
									style={{
										fontWeight: 'bold',
										border: 'none',
										fontSize: 18,
									}}
								>
									${state.total}
								</TableCell>
								<TableCell
									align="right"
									id="empty-cart-button-full"
								>
									<Button
										variant="text"
										color="primary"
										onClick={() =>
											removeFromCart({
												all: true,
											})
										}
									>
										Empty Cart
									</Button>
								</TableCell>
							</TableRow>
						</>
					)}

					<div id="cart-footer">
						{state.shoppingCart.length < 1 ? null : (
							<>
								<Button
									variant="text"
									color="primary"
									onClick={() =>
										removeFromCart({
											all: true,
										})
									}
									id="empty-cart-button-mobile"
									style={{ marginBottom: 15 }}
								>
									Empty Cart
								</Button>

								<Button
									variant="contained"
									color="primary"
									id="secure-checkout"
									startIcon={<LockIcon />}
									onClick={() => {
										handleClose();
										auth.refreshLightboxAndOpen(auth.state.merchant.amountEditable, state.shoppingCart.length);
										// window.intellipay.onSubmit();
									}}
								>
									Secure Checkout
								</Button>
							</>
						)}

						<Button
							variant="contained"
							onClick={() => handleClose()}
							id="cart-close-button"
						>
							Close
						</Button>
					</div>
				</div>
			</Fade>
		</Modal>
	);
};

const styles = {
	topBar: {
		display: 'flex',
		flexDirection: 'row',
		width: '100%',
		alignItems: 'center',
		justifyContent: 'space-between',
		paddingTop: 15,
		paddingBottom: 15,
		borderBottom: '1px solid #ddd',
	},
	title: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
	},
};

export default Cart;
